import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the paymentMethods state domain
 */

const selectPaymentMethodsDomain = state =>
  state.paymentMethods || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by PaymentMethods
 */

const makeSelectPaymentMethods = () =>
  createSelector(
    selectPaymentMethodsDomain,
    substate => substate,
  );

export default makeSelectPaymentMethods;
export { selectPaymentMethodsDomain };
